import { render, staticRenderFns } from "./resetOrModifyPassword.vue?vue&type=template&id=28030046&scoped=true&"
import script from "./resetOrModifyPassword.vue?vue&type=script&lang=js&"
export * from "./resetOrModifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetOrModifyPassword.vue?vue&type=style&index=0&id=28030046&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28030046",
  null
  
)

export default component.exports